module.exports = __webpack_public_path__ + "static/img/remark-image-text.770ea7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/remark-image-text.png
// module id = poFz
// module chunks = 1